import { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const PhoneInputField = ({ value, onChange, is_required = true }: { value: string, onChange: (value: string) => void, is_required: boolean }) => {
  const [error, setError] = useState('');

  const handleChange = (val: string) => {
    onChange(val); // on envoie la valeur au parent
    setError('');
  };

  const validatePhone = () => {
    try {
      const phoneNumber = parsePhoneNumberFromString(`+${value}`);
      if (!phoneNumber || !phoneNumber.isValid()) {
        setError('Numéro de téléphone invalide !');
      } else {
        setError('');
      }
    } catch (e) {
      setError('Format de numéro incorrect !');
    }
  };

  return (
    <div className="w-full">
      <label className="block mb-2 text-sm font-medium text-gray-700">
        Numéro de téléphone {is_required && <span className="text-red-500">*</span>}
      </label>

      <PhoneInput
        country={'gn'}
        value={value}
        onChange={handleChange}
        onBlur={validatePhone}
        containerClass="w-full"
        inputClass="!w-full !py-5 !pl-12 !pr-4 !rounded-sm 
                    !border !border-gray-300 
                    focus:!border-green-700 
                    focus:!ring-2 focus:!ring-green-700 
                    transition-all"
        buttonClass="!border-gray-300 !bg-white"
      />

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default PhoneInputField;
